"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _get = _interopRequireDefault(require("transmute/get"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _UIIconHolder = _interopRequireDefault(require("UIComponents/icon/UIIconHolder"));

var _UIUnauthedHubSpotUserAvatar = _interopRequireDefault(require("ui-addon-avatars/UIUnauthedHubSpotUserAvatar"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _utils = require("MeetingsLib/utils/utils");

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _RequestStatusSelectors = require("MeetingsLib/selectors/RequestStatusSelectors");

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var ProfileHeader = (0, _createReactClass.default)({
  displayName: "ProfileHeader",
  propTypes: {
    // passed
    avatar: _propTypes.default.string,
    booked: _propTypes.default.bool.isRequired,
    headline: _propTypes.default.string,
    profile: _propTypes.default.instanceOf(_UserProfile.default).isRequired,
    // loaded
    companyName: _propTypes.default.string,
    isFetchingCompanyName: _propTypes.default.bool,
    isFetchingPublicAvailability: _propTypes.default.bool,
    linkType: _propTypes.default.string,
    offline: _propTypes.default.bool
  },
  getDefaultHeadline: function getDefaultHeadline() {
    var _this$props = this.props,
        profile = _this$props.profile,
        companyName = _this$props.companyName,
        linkType = _this$props.linkType,
        offline = _this$props.offline,
        isFetchingCompanyName = _this$props.isFetchingCompanyName;
    var isRoundRobin = (0, _utils.getIsRoundRobin)(linkType);

    if (isRoundRobin && isFetchingCompanyName) {
      return null;
    }

    var suffix = offline ? 'offline' : 'online';
    var headerType = (0, _utils.getHeaderType)(isRoundRobin);
    var options = (0, _utils.getHeaderOptions)(isRoundRobin, companyName, profile);
    return _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "prebook." + headerType + "." + suffix,
      options: options
    });
  },
  renderImage: function renderImage() {
    var _this$props2 = this.props,
        avatar = _this$props2.avatar,
        booked = _this$props2.booked,
        isFetchingPublicAvailability = _this$props2.isFetchingPublicAvailability;

    if (isFetchingPublicAvailability) {
      return this.renderSkeletonImage();
    }

    if (booked) {
      return this.renderBookedImage();
    }

    if (avatar) {
      return this.renderAvatarImage();
    }

    return this.renderUserImage();
  },
  renderBookedImage: function renderBookedImage() {
    var offline = this.props.offline;
    var name = offline ? 'successful-send' : 'success';
    return _react.default.createElement(_UIIllustration.default, {
      name: name,
      width: "40%",
      "aria-hidden": true
    });
  },
  renderSkeletonImage: function renderSkeletonImage() {
    return _react.default.createElement("div", {
      "aria-hidden": true,
      className: "header-avatar"
    }, _react.default.createElement(_UIIconHolder.default, {
      name: "contacts",
      size: 32,
      className: "skeleton-image"
    }));
  },
  renderAvatarImage: function renderAvatarImage() {
    return _react.default.createElement(_UIImage.default, {
      className: "header-avatar avatar-image user-provided-avatar",
      src: this.props.avatar,
      shape: "circle",
      size: "responsive",
      "aria-hidden": true
    });
  },
  renderUserImage: function renderUserImage() {
    var profile = this.props.profile;
    var email = profile.email;
    if (!email) return this.renderSkeletonImage();
    return (// the avatar component doesn't support alt text, and doesn't provide useful additional info
      // so let's make this hidden to screen readers
      _react.default.createElement("div", {
        "aria-hidden": true,
        className: "header-avatar"
      }, _react.default.createElement(_UIUnauthedHubSpotUserAvatar.default, {
        hubSpotUserEmail: email,
        className: "avatar-image",
        size: "lg",
        _isHasTooltip: false // experimental prop
        ,
        source: "meetings-public"
      }))
    );
  },
  renderMessage: function renderMessage() {
    var _this$props3 = this.props,
        headline = _this$props3.headline,
        booked = _this$props3.booked,
        offline = _this$props3.offline,
        isFetchingPublicAvailability = _this$props3.isFetchingPublicAvailability;

    if (isFetchingPublicAvailability) {
      return null;
    }

    if (booked) {
      var suffix = offline ? 'offline' : 'online';
      return _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "summary.header." + suffix
      });
    }

    if (headline) {
      return headline;
    }

    return this.getDefaultHeadline();
  },
  renderHeadline: function renderHeadline() {
    var classes = 'headline m-top-4 m-bottom-0 m-x-1 overflow-y-auto' + (this.props.booked ? " success-header" : "");
    return _react.default.createElement(_H.default, {
      "aria-level": 1,
      className: classes,
      style: {
        alignSelf: 'stretch'
      }
    }, this.renderMessage());
  },
  render: function render() {
    return _react.default.createElement(_UIFlex.default, {
      direction: "column",
      align: "center",
      className: "profile-header text-center"
    }, this.renderHeadline(), this.renderImage());
  }
});

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    // Rerenders component in response to translation
    activeLocale: state.activeLocale,
    companyName: state.companyName,
    isFetchingCompanyName: (0, _RequestStatusSelectors.getIsFetchingCompanyName)(state),
    isFetchingPublicAvailability: (0, _RequestStatusSelectors.getIsFetchingPublicAvailability)(state),
    linkType: (0, _get.default)('linkType', (0, _BookInfoSelectors.getBookInfo)(state)),
    offline: (0, _BookInfoSelectors.getOffline)(state)
  };
})(ProfileHeader);

exports.default = _default;
module.exports = exports.default;